import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "intro" }
const _hoisted_2 = { class: "intro__container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("source", {
  src: "https://static.serato.com/visualizer/videos/onboarding-video.mp4",
  type: "video/mp4"
}, null, -1)
const _hoisted_4 = { class: "intro__button-wrapper" }

import ForwardIcon from '@/assets/ForwardIcon.svg'
import BigButton from '@/components/common/BigButton.vue'
import { ref } from 'vue'
import UnmuteIcon from '@/assets/UnmuteIcon.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'IntroVideo',
  emits: ["skipIntro"],
  setup(__props, { emit: emits }: { emit: ({
  (event: 'skipIntro'): void;
}), expose: any, slots: any, attrs: any }) {

const introVideo = ref<HTMLVideoElement | null>(null)
const showPlayButton = ref(true)

const playSound = () => {
  if (introVideo.value) {
    introVideo.value.muted = false
    showPlayButton.value = false
  }
}




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, {
        name: "intro__fade-transition",
        appear: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("video", {
            class: "intro__video",
            ref_key: "introVideo",
            ref: introVideo,
            onEnded: _cache[0] || (_cache[0] = ($event: any) => (emits('skipIntro'))),
            playsinline: "",
            autoplay: "",
            muted: "",
            preload: "auto"
          }, [
            _hoisted_3,
            _createTextVNode(" Your browser does not support the video tag. ")
          ], 544)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_Transition, {
          name: "intro__fade-transition",
          appear: ""
        }, {
          default: _withCtx(() => [
            (showPlayButton.value)
              ? (_openBlock(), _createBlock(BigButton, {
                  key: 0,
                  class: "intro__play-button",
                  text: "Click for sound",
                  type: "secondary",
                  "is-loading": false,
                  "is-disabled": false,
                  onClick: playSound
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(UnmuteIcon))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "intro__fade-transition",
          appear: ""
        }, {
          default: _withCtx(() => [
            _createVNode(BigButton, {
              style: {"transition-delay":"3s"},
              text: "Skip intro",
              type: "secondary",
              "is-loading": false,
              "is-disabled": false,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('skipIntro')))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ForwardIcon), { class: "intro__skip-icon" })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})